module.exports = __webpack_public_path__ + "img/managment-banner.d0f8f1db.jpg";